export default "__VITE_ASSET__wd5HsZeG__"